import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { setContentToggle } from '@aarhus-university/au-designsystem-delphinus/source/js/components/content-toggle';

const AUContentToggleComponent = ({ toggled, classNames, children }) => {
  const toggleContainer = useRef();
  useEffect(() => {
    const toggle = toggleContainer.current.querySelector('.content-toggle__content');
    if (toggle) {
      const button = setContentToggle(toggle);
      button.setAttribute('aria-expanded', toggled);
    }
  }, []);
  return (
    <div ref={toggleContainer} className={classNames}>
      {children}
    </div>
  );
};

AUContentToggleComponent.defaultProps = {
  children: null,
  classNames: null,
};

AUContentToggleComponent.propTypes = {
  children: PropTypes.element,
  toggled: PropTypes.bool.isRequired,
  classNames: PropTypes.string,
};
AUContentToggleComponent.displayName = 'AUContentToggleComponent';
export default AUContentToggleComponent;
